import { useContext } from 'react';
import { SupportContext, type SupportContextValue } from '../auth/supportContext';

export function useSupportSession(): SupportContextValue {
  return useContext(SupportContext);
}
